// extracted by mini-css-extract-plugin
module.exports = {"cross":"styles-m__cross---160YG","post":"styles-m__post---2nMTY"};